import React, { Component } from 'react'
import PropTypes from 'prop-types'
import SwipeableShowcase from './SwipeableShowcase'
import throttle from 'lodash/throttle'
import TagIcon from 'react-icons/lib/fa/tags'

import './GridShowcase.scss'

export default class GridShowcase extends Component {

  constructor (props) {
    super(props)

    this.state = {
      products: [],
      selectedImage: null,
      previousTouchY: null,
      touchEnded: true,
      topShowcaseHidden: true
    }

    this.onGridMove = this.onGridMove.bind(this)
    this.handleGridScroll = this.handleGridScroll.bind(this)
  }

  componentDidMount () {
    let iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
    document.getElementsByClassName('js-grid-box')[0].addEventListener('touchstart', e => this.onGridTouchStart(e), false)
    if (!iOS) {
      document.getElementsByClassName('js-grid-box')[0].addEventListener('touchmove', throttle(this.onGridMove, 300), false)
      document.getElementsByClassName('js-grid-box')[0].addEventListener('touchend', e => this.onGridTouchEnd(e), false)
    } else {
      document.getElementsByTagName('body')[0].addEventListener('touchstart', e => this.iOSScrollFix(e), false)
      document.getElementsByClassName('js-grid-box')[0].addEventListener('touchmove', throttle(this.handleGridScroll, 300), false)
    }
  }

  iOSScrollFix (e) {
    const grid = document.getElementsByClassName('js-grid-box')[0]
    if (grid.scrollTop === 0) {
      grid.scrollTop = 1
    }
  }

  setProducts (products) {
    if (products && products.length < 4 && products.length !== 0) {
      this.setState(() => {
        let nextProductsLength = products.length
        let nextProducts = products.slice()
        for (let i = nextProductsLength; i < 4; i++) {
          nextProducts.push({invisibleProduct: true})
        }
        return {
          products: nextProducts
        }
      })
    } else {
      this.setState({products})
    }
  }

  onGridTouchStart (e) {
    let touch = e.touches[0]

    this.setState({
      previousTouchY: touch.pageY,
      touchEnded: false
    })
  }

  onGridTouchEnd (e) {
    const grid = document.getElementsByClassName('js-grid-box')[0]

    grid.classList.remove('in_grid__images--pulled')

    this.setState({
      touchEnded: true
    })
  }

  onGridMove (e) {
    this.handleGridScroll(e)
    const grid = document.getElementsByClassName('js-grid-box')[0]
    let scrollTop = grid.scrollTop

    let touch = e.touches[0]

    if (this.state.previousTouchY < touch.pageY && scrollTop === 0 && !this.state.touchEnded) {
      grid.classList.add('in_grid__images--pulled')
    } else {
      grid.classList.remove('in_grid__images--pulled')
    }
  }

  handleGridScroll (e) {

    let touch = e.touches[0]

    if (this.state.previousTouchY > touch.pageY) {
      this.setState({
        topShowcaseHidden: true
      })
    }
  }

  render () {
    // console.log(this.props.showcases)
    const { gridColumns } = this.props
    const { topShowcaseHidden, products } = this.state
    return (
      <div className='in_grid'>
        <div className={`in_grid__main ${!products || products.length < 1 || topShowcaseHidden ? 'in_grid__main--short' : ''}`}>
          <div className='in_grid__customer-logo noBounce'></div>
          {!products || products.length < 1
          ? null
          : (
            <div className={`in_grid__swipeable--container ${topShowcaseHidden ? 'in_grid__swipeable--container--hidden' : ''}`}>
              <SwipeableShowcase
                products={this.state.products}
                showProduct={this.props.showProduct}
                getProductInfo={this.props.getProductInfo}
                />
            </div>
            )
          }
        </div>
        <div id='in_grid_images' className={`in_grid__images js-grid-box ${!products || products.length < 1 || topShowcaseHidden ? 'in_grid__images--tall' : ''}`} >
          {this.props.showcases.map((slide, index) =>
            <div className={`image__container js-scroll ${gridColumns === 3 ? '' : 'image__container--one-fourth'}`} key={index} onClick={() => {
              this.setState({
                selectedImage: index,
                topShowcaseHidden: false
              })
              this.setProducts(slide.products)
            }}>
              <img className='js-scroll' src={slide.image} />
              {slide.products && slide.products.length > 0 && <TagIcon className='image__container--tag-icon' />}
              {index === this.state.selectedImage &&
                <div className='image__container--mask'></div>
              }
            </div>
          )}
        </div>
        { this.props.cart && this.props.cart.products && this.props.cart.products.length > 0
          ? <div className='in_grid__cart-link' onClick={() => this.props.switchCart()}></div>
          : null
        }
      </div>
    )
  }

  static defaultProps = {
    showcases: [],
  }

  static propTypes = {
    showcases: PropTypes.array.isRequired,
    showProduct: PropTypes.func.isRequired,
    switchCart: PropTypes.func.isRequired,
    gridColumns: PropTypes.number,
    getProductInfo: PropTypes.func.isRequired,
    cart: PropTypes.object
  }
}



// WEBPACK FOOTER //
// ./src/templates/insta/components/showcase/GridShowcase.js